/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vuex from 'vuex';
import VueAxios from 'vue-axios';
import VueRouter from 'vue-router';
import routes from './routes';
import vuex from './store';
import can from './can';
import route from './urlex/route';
import Api from './services/ApiPlugin';
// import Route from './services/RoutePlugin';
import Notifications from 'vue-notification';

import * as VueGoogleMaps from 'vue2-google-maps';

// leaflet map begin
import { Icon }  from 'leaflet'
import 'leaflet/dist/leaflet.css'

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
// leaflet map end

import Moment from 'vue-moment';
import Datepicker from 'vuejs-datepicker';
//import VueMousetrap from 'vue-mousetrap';
import VueMousetrapPlugin from 'vue-mousetrap/vue2'

import DateTimePicker from 'vue-bootstrap-datetimepicker';
import VueSweetalert2 from 'vue-sweetalert2';
import VueToast from './plugins/toast';
import Navigation from "./pages/main/Navigation";
import LockScreen from "./components/LockScreen";
import 'vue-search-select/dist/VueSearchSelect.css'

require('es6-object-assign').polyfill();
require('./bootstrap');

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueToast);
//import VueMousetrapPlugin from 'vue-mousetrap/vue2'
const store = new Vuex.Store(vuex);

Vue.use(Api, {store});
// Vue.use(Route);

Vue.mixin({
    methods: {
        toast(title, type = 'success') {
            let Toast = Swal.mixin({toast: true, position: 'top-end', showConfirmButton: false, timer: 3000});
            Toast.fire({
                type: type,
                title: title
            })
        },
        i18n(value) {
            let current = this.$store.state.currentLang;
            let basket = this.$store.state.lang[current];
            if (basket !== undefined) {
                let word = basket[value];
                if (word !== undefined) {
                    return word;
                }
            }
            return value;
        },
        logout: function (cb) {
            if (confirm('Вы действительно хотите выйти из своего аккаунта?')) {
                this.$api.post('auth.logout').finally(() => {
                    localStorage.clear();
                    this.$store.commit('logout');
                    this.$router.push({name: 'login'});
                    // if (typeof cb === 'function') { cb() }
                    store.commit('unlockScreen');
                });
            }
        },
        can,
        route
    }
});
Vue.use(Notifications);
Vue.use(Moment);
//Vue.use(VueMousetrap);

Vue.use(VueMousetrapPlugin);

Vue.use(Datepicker);
Vue.use(DateTimePicker);
Vue.use(VueGoogleMaps, {load: {key: 'AIzaSyB4comL9rm4zlzLsE0MVsraCVTt4uSSF_U', libraries: 'places', v: '3.26'}});
let rbase = window.location.hostname === atob('Y3JtLmF2dG90aWNrZXQudXo=') ? '/' : '/crm/';
let router = new VueRouter({linkExactActiveClass: 'active', routes: routes, mode: 'history', base: rbase});


router.beforeEach((to, from, next) => {
    let authToken = localStorage.getItem('authToken');
    if (to.matched.some(record => record.meta.guest)) {
        if (authToken == null) {
            next()
        } else {
            next({name: 'main'})
        }
    } else {
        if (authToken == null) {
            next({
                name: 'login',
                params: {nextUrl: to.fullPath}
            })
        } else {
            if (to.matched.some(record => record.meta.permissions)) {
                if (to.matched.some(record => {
                    let hasperm = false;
                    record.meta.permissions.forEach(p => {
                        hasperm = router.app.can(p);
                    });
                    return hasperm;
                })) {
                    next();
                } else {
                    next({name: 'main'})
                }
            } else {
                next()
            }
        }
    }
});


window.busApp = new Vue({
    el: '#app',
    router: router,
    store,
    components: {Navigation, LockScreen},
    data: {},
    created() {
        this.initLockScreen();
        if (this.$router.currentRoute.name !== 'login') {
            this.checkAuth();
            this.$api.post('auth.permissions')
                .then(({data}) => {
                    if (data) {
                        this.$store.commit("loadPerms", data);
                    }
                }).finally(() => {
                this.$store.commit('finishLoading')
            });
        } else {
            this.$store.commit('finishLoading')
        }
    },
    mounted() {
    },
    methods: {
        checkAuth() {
            let authstr = localStorage.getItem("auth");
            if (authstr) {
                let authObj = JSON.parse(authstr);
                this.$store.commit("loadAuth", authObj);
            } else this.$router.replace({name: "login"});
        },
        initLockScreen() {
            window.onkeydown = window.onclick = this.updateLastdate;
            let checkLS = localStorage.getItem('screenLocked');
            setInterval(this.checkLastdate, 1000);
            if (parseInt(checkLS) === 10) {
                this.$store.commit('lockScreen');
            }
        },
        updateLastdate(e) {
            if (!this.isScreenLocked) {
                this.$store.commit('unlockScreen');
            } else {
                if (e.which === 9) {
                    e.preventDefault()
                }
            }
        },
        checkLastdate() {
            if (!this.isScreenLocked && this.isAuthorized) {
                let now = +new Date();
                let diff = now - this.lastdate;
                let expiryInMs = 1000 * 300;
                if (diff > expiryInMs) {
                    this.$store.commit('lockScreen');
                }
            }
        },
    },
    computed: {
        isScreenLocked() {
            return this.$store.state.screenLocked;
        },
        isAuthorized() {
            return this.$store.state.isAuthorized;
        },
        lastdate() {
            return this.$store.state.userLastdate;
        }
    },
});
